import type { SVGProps } from 'react';

export default function MoneyBag(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 8.00027C10 8.00027 10.5 8.25027 12 8.25027C13.5 8.25027 14 8.00027 14 8.00027C14 8.00027 15.75 5.75027 18 5.75027M4.75 15.0003C4.75 18.0003 8 19.25 12 19.25C16 19.25 19.25 18 19.25 15C19.25 13.4351 17.5494 10.8703 15.9224 9.73117C14.3213 8.61021 13.4252 6.61811 14 4.75H10C10.5748 6.61812 9.67878 8.61025 8.07765 9.73126C6.45061 10.8704 4.75 13.4354 4.75 15.0003Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
